import * as massNotification from '@store/_reducers/users/mass-notification.reducer';
import * as notify from '@store/_reducers/users/notify.reducer';
import * as loader from '@store/_reducers/loader/loader.reducer';
export default {
  ...notify,
  ...massNotification,
  ...loader,
};
